export default __webpack_public_path__ + "static/media/logo.337e8feb.png";